<template>
  <component
    :is="tag">
    <span v-if="!inEditMode">{{ input }}</span>
    <b-input-group
      v-else
      @keydown.esc="onCancel"
      @keydown.enter="onSave">
      <b-form-input
        id="editable-input"
        v-model="updatedValue" />
      <b-input-group-append>
        <b-button
          variant="primary"
          @click.prevent="onSave">
          <i class="fas fa-check" />
        </b-button>
        <b-button
          variant="outline-secondary"
          @click.prevent="onCancel">
          <i class="fas fa-ban" />
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </component>
</template>

<script>
export default {
  name: "PaywallFormInputEditable",
  props:  {
    value: {
      type: String,
      required: false,
      default: null,
    },
    tag: {
      type: String,
      required: false,
      default: "div",
    },
    inEditMode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      originalValue: null,
      updatedValue: null,
    }
  },
  computed: {
    input() {
      return this.value || "(Change Me)"
    },
  },
  watch: {
    inEditMode(newVal, oldVal) {
      if (newVal === true && oldVal === false) {
        this.originalValue = this.value
        this.updatedValue = this.value
        this.$nextTick(() => {
          document.getElementById('editable-input').focus()
        })
      }
    },
  },
  methods: {
    onCancel() {
      this.$emit('input', this.originalValue)
      this.$emit('set-edit-mode', false)
    },
    onSave() {
      this.$emit('input', this.updatedValue)
      this.$emit('set-edit-mode', false)
    },
  },
}
</script>

<style scoped>

</style>
